import { render, staticRenderFns } from "./bzgzb.vue?vue&type=template&id=1c33e53b&scoped=true&"
import script from "./bzgzb.vue?vue&type=script&lang=js&"
export * from "./bzgzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c33e53b",
  null
  
)

export default component.exports